import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Input,
  Form,
  Switch,
  Select,
  Popconfirm,
  Button,
  Modal,
  Alert,
  Table,
  Tag,
  message,
  Tooltip,
  Space,
  Upload,
  DatePicker,
  Progress,
} from 'antd';
import { PageHeader } from '../../components/page-headers/page-headers';
import moment from 'moment';
import axios from '../../backendService';
import axiosUpload from '../../backendServiceForUpload';
import { GlobalUtilityStyle, PaginationStyle } from '../../container/styled';
import { FaVideo, FaImage, FaEye } from 'react-icons/fa6';
import { BiEditAlt } from 'react-icons/bi';
import { MdDelete } from 'react-icons/md';
import AWS from 'aws-sdk';

const IMAGE_FOLDER = 'thumbnails';
const S3_BUCKET = 'hls-streaming-classroom';
const REGION = 'ap-south-1';
const ACCESS_KEY = 'AKIA4T4OCFU2JPJX5VW5';
const SECRET_ACCESS_KEY = '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';

const s3 = new AWS.S3({
  endpoint: 'https://hls-streaming-classroom.s3.ap-south-1.amazonaws.com',
  accessKeyId: 'AKIA4T4OCFU2JPJX5VW5',
  secretAccessKey: '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',
  region: 'ap-south-1',
  s3BucketEndpoint: true,
});
const getFileTypeFolder = (fileType) => {
  if (fileType.includes('image')) return 'thumbnails';
  if (fileType.includes('pdf')) return 'pdf';
  if (fileType.includes('video')) return 'videos';
  // Add more file types as needed
  return 'documents'; // default folder
};
const { TextArea } = Input;

function Batch() {
  const [form] = Form.useForm();
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [uploadedImageName, setUploadedImageName] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imageFileName, setImageFileName] = useState('');
  const [imageURL, setImageURL] = useState(null);
  const [updatedImageURL, setUpdatedImageURL] = useState(null);
  const [imageReady, setImageReady] = useState(null);
  const [imageUploadStatus, setImageUploadStatus] = useState('');
  const [imageUploadPercentage, setImageUploadPercentage] = useState(0);
  const [courseData, setCourseData] = useState([]);
  const [courseLoading, setCourseLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showImageUploadBar, setShowImageUploadBar] = useState(true);
  const [currBatch, setCurrBatch] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [batchToDlt, setBatchToDlt] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // Fetch data from the server
  const fetchData = async (page = 1, pageSize = 10, query = '') => {
    setLoading(true); // Show loading spinner
    try {
      const response = await axios.get(`/batch/paginatedBatches`, {
        params: { page, pageSize, name: query },
      });

      if (response.data.success) {
        const { batches, totalRecords, currentPage, totalPages } = response.data.data;

        setData(batches); // Update the table data with batches
        setPagination({
          current: currentPage,
          pageSize,
          total: totalRecords,
        });
      } else {
        message.error(response.data.message || 'Failed to fetch data');
      }
    } catch (error) {
      console.error('Error fetching data:', error.response || error.message);
      message.error('Failed to fetch data. Please try again later.');
    } finally {
      setLoading(false); // Hide loading spinner
    }
  };

  // On component mount or search query/pagination change
  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize, searchQuery);
  }, [pagination.current, pagination.pageSize, searchQuery]);

  // Handle search query input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPagination((prev) => ({ ...prev, current: 1 })); // Reset to the first page on search
  };

  // Handle table pagination
  const handleTableChange = (pagination) => {
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };
  // Open a modal by clicking new course
  const showModal = () => {
    setIsVisible(true);
    setCurrBatch(null);
    setImageFileName(null);
    setStartDate(null);
    setImageURL(null);
    setUpdatedImageURL(null);
    setImageUploadStatus(null);
    form.resetFields();
    setImageUploadPercentage(0);
  };

  //Close the modal
  const onCancel = () => {
    setIsVisible(false);
  };

  // Handle search query input change
  const onSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter the data based on the search query
  const filteredData = data.filter(
    (item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()),
    // item.name.toLowerCase().startsWith(searchQuery.toLowerCase()),
  );

  // Make the API request to update the switch status
  const handleSwitchToggle = async (id, enabled) => {
    try {
      const response = await axios.put(`/batch/update-batch/${id}`, { isActive: enabled });
      fetchData();
    } catch (error) {
      console.error('Error updating switch status:', error);
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '250px',
              paddingLeft: '5px',
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Course',
      dataIndex: 'course',
      key: 'course',
      render: (text) => (
        <Tooltip title={text.courseName}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '250px',
            }}
          >
            {text.courseName}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: 'Class type',
      dataIndex: 'class_type',
      key: 'class_type',
    },
    {
      title: 'Batch Owner',
      dataIndex: 'batch_owner',
      key: 'batch_owner',
    },
    {
      title: 'No. of students',
      dataIndex: 'students',
      key: 'students',
      render: (text, record) => <p className="flex items-center justify-center w-full">{text.length}</p>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '250px',
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Syllabus Type',
      dataIndex: 'syllabus_type',
      key: 'syllabus_type',
    },
    {
      title: 'Language',
      dataIndex: 'language',
      key: 'language',
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (enabled, record) => (
        <Switch checked={enabled} size="small" onChange={(checked) => handleSwitchToggle(record._id, checked)} />
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <div className="flex items-center justify-center gap-3">
          <Tooltip title={`Edit Details`}>
            <BiEditAlt
              className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title={`Delete Batch`}>
            <MdDelete
              color="red"
              className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
              onClick={() => handleDelete(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleEdit = (record) => {
    setCurrBatch(record);
    setIsVisible(true);
  };

  const handleDelete = async (record) => {
    setBatchToDlt(record._id);
    setOpenDelete(true);
  };

  const closeDeleteModal = () => {
    setOpenDelete(false);
  };

  // Populate form on edit button
  useEffect(() => {
    if (currBatch) {
      form.setFieldsValue({
        name: currBatch?.name,
        description: currBatch?.description,
        courseName: currBatch?.course.courseName,
        class_type: currBatch?.class_type,
        batch_owner: currBatch?.batch_owner,
        language: currBatch?.language,
        syllabus_type: currBatch?.syllabus_type,
        startDate: moment(currBatch?.startDate), // Convert to moment object
        endDate: moment(currBatch?.endDate), // Convert to moment object
      });
      setImageFileName(currBatch.bannerImage);
      setUpdatedImageURL(currBatch.bannerImage);
      setImageUploadStatus('Current file');
      setImageUploadPercentage(100);
    }
  }, [currBatch, form]);

  // Display Banner image
  const handleViewImage = (imageLink) => {
    console.log(imageLink);
    window.open(imageLink, '_blank');
  };

  // Delete uploaded banner image from s3 bucket
  const clearExistingBannerImage = async () => {
    const link = currBatch.bannerImage;
    const linkArr = link.split('/');
    const fileKey = linkArr[linkArr.length - 1];
    await deleteUploadedImage(fileKey);
    setImageUploadPercentage(0);
    setImageUploadStatus('');
    setImageURL(null);
    setUpdatedImageURL(null);
    form.setFieldValue('videoThumbnail', null);
    setImageFileName('');
    setImageFile(null);
  };

  const handleImageFileUpload = async (file) => {
    setImageReady(false);
    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1e9);
    const updatedFileName = file.name.replace(/\s/g, '') + '_' + uniqueSuffix;
    setUploadedImageName(updatedFileName);

    const folderName = getFileTypeFolder(file.type);
    const s3Key = `${folderName}/${updatedFileName}`;

    const params = {
      Bucket: S3_BUCKET,
      Key: s3Key,
      Body: file,
      ACL: 'public-read',
      ContentType: file.type,
      ContentDisposition: 'inline',
      CreateBucketConfiguration: {
        LocationConstraint: 'ap-south-1',
      },
    };

    try {
      setImageUploadStatus(`Uploading in progress...`);
      setImageUploadPercentage(0);
      // const formData = new FormData();
      // formData.append('file', file);

      // const response = await axiosUpload.post(`/videos/upload-to-s3-bucket/${updatedFileName}`, formData, {
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //   },
      // });

      s3.upload(params, (err, data) => {
        if (err) {
          console.log(err);
        }

        console.log(`File uploaded successfully. ${data.Location}`);
        const imageURLReceived = data && data.Location;
        if (imageURLReceived) {
          setImageURL(imageURLReceived);
          message.success('Image uploaded successfully');
        } else {
          message.error('Failed to get image URL');
        }
        setImageUploadStatus(`Image uploaded successfully.`);
        setImageReady(true);
      }).on('httpUploadProgress', (progressData) => {
        const calculatedProgress = Math.round((progressData.loaded / progressData.total) * 100);
        setImageUploadPercentage(calculatedProgress);
      });
      // console.log(response.data);
      // const imageURLReceived = response.data && response.data.Location;
      // if (imageURLReceived) {
      //   setImageURL(imageURLReceived);
      //   message.success('Image uploaded successfully');
      // } else {
      //   message.error('Failed to get image URL');
      // }
      // setImageUploadStatus(`Image uploaded successfully.`);
      // setImageReady(true);
    } catch (error) {
      console.error('Error uploading image:', error);
      message.error('Failed to upload image');
    }
  };

  const deleteUploadedImage = async (fileName) => {
    try {
      // You'll need to store the folder name when uploading, or determine it from file type
      const folderName = 'thumbnails'; // or get it dynamically
      await axios.delete(`/videos/gets3objects/delete-from-s3/${folderName}/${fileName}`);
      message.success(`File deleted successfully, upload a new file`);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error('Failed to delete file');
    }
  };

  const clearUploadedImageFile = async () => {
    await deleteUploadedImage(uploadedImageName);
    setImageUploadStatus('');
    setImageUploadPercentage(0);
    setImageURL(null);
    form.setFieldValue('videoThumbnail', null);
    form.setFieldValue('imageURL', null);
    setImageFileName('');
    setImageFile(null);
  };

  const clearUploadedImageFileAfterSubmission = async () => {
    setImageUploadStatus('');
    setImageUploadPercentage(0);
    setImageURL(null);
    form.setFieldValue('videoThumbnail', null);
    form.setFieldValue('imageURL', null);
    setImageFileName('');
    setImageFile(null);
  };

  // Function to handle start date change
  const handleStartDateChange = (value) => {
    setStartDate(value);
    form.setFieldsValue({ endDate: null }); // Reset end date when start date changes
  };

  // Function to disable dates before and including the start date in the end date picker
  const disabledEndDate = (current) => {
    // Disable dates up to and including the start date
    return current && startDate ? current.isSameOrBefore(startDate, 'day') : false;
  };

  // Submit new form
  const handleFormSubmit = async (values) => {
    setLoading(true);
    let data = {
      name: values.name,
      bannerImage: updatedImageURL,
      description: values.description,
      course: values.courseName,
      class_type: values.class_type,
      batch_owner: values.batch_owner,
      syllabus_type: values.syllabus_type,
      language: values.language,
    };
    if (values.startDate && values.endDate) {
      const start_date = form.getFieldValue('startDate').format('DD MMM YYYY');
      const end_date = form.getFieldValue('endDate').format('DD MMM YYYY');
      data = { ...data, startDate: start_date, endDate: end_date };
    }
    try {
      const res = await axios.post('/batch/add-new-batch', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(res.data);
      setLoading(false);
      clearUploadedImageFileAfterSubmission();
      fetchData();
      message.success('Batch created');
      form.resetFields();
      onCancel();
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
      setLoading(false);
      message.error('Something went wrong, check if all fields are correct');
    }
  };

  // Submit edit form
  const handleEditFormSubmit = async (values) => {
    setLoading(true);
    let data = {
      name: values.name,
      bannerImage: updatedImageURL,
      description: values.description,
      course: currBatch.course._id,
      class_type: values.class_type,
      batch_owner: values.batch_owner,
      syllabus_type: values.syllabus_type,
      language: values.language,
    };
    if (values.startDate && values.endDate) {
      const start_date = form.getFieldValue('startDate').format('DD MMM YYYY');
      const end_date = form.getFieldValue('endDate').format('DD MMM YYYY');
      data = { ...data, startDate: start_date, endDate: end_date };
    }
    try {
      console.log(data, '-------------------------------update data');
      const res = await axios.put(`/batch/update-batch/${currBatch._id}`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(res.data);
      setLoading(false);
      clearUploadedImageFileAfterSubmission();
      fetchData();
      message.success('Batch updated');
      form.resetFields();
      onCancel();
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
      setLoading(false);
      message.error('Something went wrong, check if all fields are correct');
    }
  };

  // Delete Batch
  const handleBatchDelete = async () => {
    const hide = message.loading('Please wait while we are deleting the batch and related data...', 0); // 0 means it will persist
    try {
      const response = await axios.delete(`/batch/delete-batch/${batchToDlt}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const res = await response.data;
      // Dismiss the loading message
      hide();
      if (res.status_code === 200) {
        form.resetFields();
        message.success(response.data.message);
        fetchData();
        closeDeleteModal();
      } else if (res.status_code === 400) {
        form.resetFields();
        message.error(response.data.message, 4);
        fetchData();
        closeDeleteModal();
      }
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      message.error(error.message);
    }
  };

useEffect(() => {
  console.log('imageURL', imageURL);
  if (imageURL) {
    let finalImageURL = imageURL;
    
    if (!imageURL.includes('https://')) {
      // Construct URL with proper folder structure
      const folderName = 'thumbnails'; // or determine dynamically
      finalImageURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${folderName}/${imageURL}`;
    } else if (imageURL.includes('amazonaws.com')) {
      finalImageURL = imageURL;
    }
    
    setImageURL(finalImageURL);
    setUpdatedImageURL(finalImageURL);
    console.log(`updated imageURL`, finalImageURL);
  }
}, [imageURL]);

  return (
    <>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title="  "
      />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <>
              <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
                <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                  <div className="flex items-center justify-between gap-[15px]">
                    <h1 className="mb-0 inline-block text-ellipsis text-[18px] font-semibold sm:text-center">Batch</h1>
                    <Input
                      className="w-80"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      placeholder="Search by batch name..."
                    />
                  </div>
                  <Button
                    onClick={showModal}
                    className="h-[50px] px-6 text-xs font-medium bg-primary-transparent text-primary border-none"
                    transparented
                    type="primary"
                    size="large"
                  >
                    + Add Batch
                  </Button>
                </div>
                {/*Display courses list */}
                <div className="mt-0.5">
                  <>
                    <GlobalUtilityStyle>
                      <PaginationStyle>
                        <div className="table-pl-0 hover-tr-none table-pt-15 table-responsive ant-pagination-custom-style [&>div>div>div>ul]:pt-[30px] [&>div>div>div>ul]:mt-[20px] [&>div>div>div>ul]:border-normal dark:[&>div>div>div>ul]:border-white10 [&>div>div>div>ul]:border-t-1 [&>div>div>div>ul]:justify-center">
                          <Table
                            dataSource={data}
                            columns={columns}
                            rowKey={(record) => record._id}
                            pagination={{
                              current: pagination.current,
                              pageSize: pagination.pageSize,
                              total: pagination.total,
                              onChange: (page, pageSize) => handleTableChange({ current: page, pageSize }),
                              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                              showSizeChanger: true,
                            }}
                            loading={loading}
                          />
                        </div>
                      </PaginationStyle>
                    </GlobalUtilityStyle>
                  </>
                </div>
              </div>
              <Modal
                open={isVisible}
                style={{ top: 20 }}
                width={1000}
                // title="Add a new batch"
                title={currBatch === null ? 'Add a New Batch' : 'Update Batch'}
                // okText="Create"
                okText={currBatch === null ? 'Create' : 'Update'}
                cancelText="Cancel"
                onCancel={onCancel}
                onOk={() => {
                  form
                    .validateFields()
                    .then((values) => {
                      if (currBatch === null) {
                        if (imageReady === false) {
                          message.warning(`Wait for image upload to finish`);
                        } else if (imageReady === null) {
                          message.warning(`You must upload an image`);
                        } else {
                          handleFormSubmit(values);
                        }
                      } else {
                        if (updatedImageURL === null || updatedImageURL === '') {
                          message.error(`Please wait for file upload to finish`);
                        } else {
                          handleEditFormSubmit(values);
                        }
                      }
                    })
                    .catch((info) => {
                      console.log('Validate Failed:', info);
                    });
                }}
              >
                <Form
                  form={form}
                  layout="horizontal"
                  name="form_in_modal"
                  initialValues={{
                    modifier: 'public',
                  }}
                >
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter name of the batch',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the name of batch" />
                  </Form.Item>
                  <Space style={{ display: 'flex', justifyContent: 'start' }} wrap>
                    <Form.Item
                      size="large"
                      name="videoThumbnail"
                      rules={[
                        {
                          required: updatedImageURL === null ? true : false,
                          message: 'Please upload a plan banner image',
                        },
                      ]}
                    >
                      <Upload
                        style={{ width: '100%' }}
                        maxCount={1}
                        beforeUpload={(file) => {
                          const isAllowedType = file.type.includes('image');
                          const isWithinSizeLimit = file.size <= 5024 * 1024;
                          if (!isAllowedType) {
                            message.error('Only jpg, png files are allowed');
                            return Upload.LIST_IGNORE;
                          }
                          if (!isWithinSizeLimit) {
                            message.error('Image size must be within 5 MB');
                            return Upload.LIST_IGNORE;
                          }
                          return true; // Allows the upload to proceed
                        }}
                        customRequest={(info) => {
                          handleImageFileUpload(info.file);
                          setImageFile(info.file);
                          setImageFileName(info.file.name);
                        }}
                        showUploadList={false}
                      >
                        <Button
                          style={{ width: '100%' }}
                          size="large"
                          type="primary"
                          icon={<FaImage />}
                          className="text-sm text-blue-700 gap-2 flex items-center justify-start"
                        >
                          Upload a banner Image
                        </Button>
                      </Upload>
                    </Form.Item>
                    {imageFileName !== '' && imageUploadStatus == 'Image uploaded successfully.' && (
                      <Form.Item>
                        <Space wrap>
                          {imageFileName ? imageFileName : ''}
                          {imageFileName !== '' && (
                            <Button
                              onClick={clearUploadedImageFile}
                              type="default"
                              size="small"
                              className="bg-red-500 text-white"
                            >
                              Delete
                            </Button>
                          )}
                        </Space>
                      </Form.Item>
                    )}
                    {imageUploadStatus !== '' && (
                      <div className="text-xs text-green-500" style={{ color: 'green' }}>
                        {imageUploadStatus}
                      </div>
                    )}
                    {imageUploadStatus === 'Current file' && (
                      <div className="flex items-center gap-2">
                        <Button type={'primary'} size={'small'} onClick={() => handleViewImage(updatedImageURL)}>
                          View Image
                        </Button>
                        <Button
                          onClick={clearExistingBannerImage}
                          type="default"
                          size="small"
                          className="bg-red-500 text-white"
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                  </Space>
                  {/* Image upload bar */}
                  <div className="mb-5">{showImageUploadBar && <Progress percent={imageUploadPercentage} />}</div>

                  <Form.Item
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter description of the batch',
                      },
                    ]}
                  >
                    <TextArea type="textarea" rows={4} cols={4} placeholder="Enter batch description" />
                  </Form.Item>
                  <Form.Item name="courseName" rules={[{ required: true, message: 'Please select a course!' }]}>
                    <Select placeholder="Select course" disabled={currBatch !== null}>
                      {courseLoading && courseData.length === 0 ? (
                        <Select.Option value={null}>Loading courses .....</Select.Option>
                      ) : courseData.length === 0 ? (
                        <Select.Option value={null}>No courses assigned.</Select.Option>
                      ) : (
                        courseData.map((course) => (
                          <Select.Option key={course.courseName} value={course._id}>
                            {course.courseName}
                          </Select.Option>
                        ))
                      )}
                    </Select>
                  </Form.Item>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        className="min-w-screen"
                        name="startDate"
                        rules={[{ required: true, message: 'Please select start date!' }]}
                      >
                        <DatePicker
                          style={{ width: '100%' }} // Set the width to 100%
                          placeholder="Select batch start date"
                          onChange={handleStartDateChange}
                          disabledDate={(current) => {
                            return current && current < moment().startOf('day');
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="endDate" rules={[{ required: true, message: 'Please select end date!' }]}>
                        <DatePicker
                          style={{ width: '100%' }} // Set the width to 100%
                          placeholder="Select batch end date"
                          disabled={!startDate}
                          disabledDate={disabledEndDate}
                          // disabledDate={(current) => {
                          //   return current && current < moment().startOf('day');
                          // }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    name="class_type"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter class type',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the type of class" />
                  </Form.Item>
                  <Form.Item
                    name="batch_owner"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter batch owner name',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the batch owner name" />
                  </Form.Item>
                  <Form.Item
                    name="syllabus_type"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter type of syllabus',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the syllabus type" />
                  </Form.Item>
                  <Form.Item
                    name="language"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter language of batch',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the language of batch" />
                  </Form.Item>
                </Form>
              </Modal>
            </>
          </Col>
        </Row>
      </main>

      {/* Delete modal */}
      <Modal
        title={
          <div>
            <h1>Are you sure you want to delete this batch?</h1>
            <span className="text-sm font-normal">
              This will further delete several records and entries linked with the current batch.
            </span>
          </div>
        }
        open={openDelete}
        onCancel={closeDeleteModal}
        footer={null}
      >
        <div className="flex items-center justify-end gap-2">
          <Button onClick={closeDeleteModal} type={'ghost'}>
            Cancel
          </Button>
          <Button onClick={handleBatchDelete} type={'danger'}>
            Delete
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default Batch;
